import jwtAuthAxios from "./auth/jwtAuth";

const bugReportServices = {};

// `index` devuelve { data: [...], meta: { current_page, total_pages, total_count, open_count } }.
bugReportServices.getBugReports = async (params = "") => {
    const { data } = await jwtAuthAxios.get(`/bug_reports${params}`);
    return data;
};

// `show` y `update` devuelven el reporte plano, sin root.
bugReportServices.getBugReport = async (id) => {
    const { data } = await jwtAuthAxios.get(`/bug_reports/${id}`);
    return data;
};

bugReportServices.reviewBugReport = async (id, payload) => {
    const { data } = await jwtAuthAxios.patch(`/bug_reports/${id}`, { bug_report: payload });
    return data;
};

export default bugReportServices;
